<script setup>
import {ref, computed, watch, nextTick} from 'vue'
import {useItemDataStore} from '@/stores/itemData'
import {useAppStore} from '@/stores/appStore'

const props = defineProps({
    fileId: Number,
    sizes: String,
    alt: String,
    onClick: Function,
})

const appStore = useAppStore()
const itemDataStore = useItemDataStore()

// --- State ---

const picture = ref(null)
const types = ref({
    // 'image/webp': 'webp',
})
const show = ref(false)
const file = ref(null)

// --- Computed ---

const widths = computed(() => {
    if (file.value && picture.value) {
        let pictureWidth = picture.value.clientWidth
        let result = []
        for (let i = 100; i <= file.value.width; i += 100) {
            // Avoid small images being stretched
            if (i >= pictureWidth) {
                result.push(i)
            }
        }
        return result
    }
    return []
})

const src = computed(() => {
    return file.value ? appStore.cdnSrc(file.value.fileName) : ''
})

// --- Methods ---

const getSrcset = (format) => {
    let srcs = []

    widths.value.forEach((width) => {
        let s = appStore.imageWidthSrc(
            file.value.fileName,
            file.value.width,
            file.value.modifiedDate,
            width
        )
        s += ' ' + width + 'w'
        srcs.push(s)
    })

    let lastWidth = widths.value[widths.value.length - 1]
    if (lastWidth && lastWidth < file.value.width) {
        let nextWidth = lastWidth + 100
        let s = appStore.fileSrc(file.value.fileName)
        s += ' ' + nextWidth + 'w'
        srcs.push(s)
    }

    nextTick(() => {
        show.value = true
    })

    return srcs.join(',')
}

const setHeight = () => {
    if (picture.value) {
        picture.value.style.maxHeight = picture.value.clientWidth + 'px'
    }
}

const fetchFileData = (id) => {
    if (!id) {
        file.value = null
        return
    }

    itemDataStore.get({
            tableName: 'files',
            id: id
        })
        .then((obj) => {
            file.value = obj
            nextTick(() => {
                setHeight()
            })
        })
}

// --- Watchers ---

watch(() => props.fileId, (newId) => {
    fetchFileData(newId)
}, {immediate: true})
</script>

<template>
    <picture ref="picture">
        <source v-if="file" :sizes="sizes" :srcset="getSrcset()">

        <template v-if="file">
            <source
                v-for="(format, mimeType) in types"
                :key="format"
                :sizes="sizes"
                :srcset="getSrcset(format)"
                :src="src"
                :type="mimeType"
            >
        </template>

        <img v-if="show" :alt="alt" :src="src" @click.prevent.stop="onClick">
    </picture>
</template>

<style scoped>
picture {
    display: flex;
    align-items: center;
    height: 100%;
    overflow: hidden;
    justify-content: center;
}

img {
    max-width: 100%;
}
</style>